/* istanbul ignore file  */

import { init as initApm } from '@elastic/apm-rum'
import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import { Provider } from 'react-redux'
import App from './App'
import * as serviceWorker from './serviceWorker'
import './i18n'
import { store } from './store'
import GoogleTagManagerHelper from './utils/helpers/googleTagManagerHelper'
import MixpanelHelper from './utils/helpers/mixpanelHelper'

initApm({
  active: process.env.REACT_APP_APM_RUM_IS_ACTIVE === 'true',
  serviceName: 'agendamento-consultas',
  serverUrl:
    'https://91874f60a1874fd39810902506405dff.apm.us-east-1.aws.cloud.es.io',
  serviceVersion: process.env.REACT_APP_VERSION,
  environment: process.env.REACT_APP_NODE_ENV
})

GoogleTagManagerHelper.inicializaGTM()
GoogleTagManagerHelper.disparaEventoGtmDePaginaCarregada()

MixpanelHelper.init()

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
)

serviceWorker.unregister()
